/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import Category from 'bundles/degree-home/components/v3-dpm/components/Category';
import CurriclumHeader from 'bundles/degree-home/components/v3-dpm/components/CurriculumHeader';
import CurriculumDataContextProvider from 'bundles/degree-home/components/v3-dpm/context/CurriculumDataContext';
import DuplicateCoursesDialog from 'bundles/degree-home/components/v3-dpm/dialogs/DuplicateCoursesDialog';
import type {
  UseCurriculum_DegreeCategoryFragment as CategoryFragmentProps,
  UseCurriculum_DegreeCurriculumFragment as DegreeCurriculumFragment,
  UseCurriculum_PbaCurriculumFragment as PbaCurriculumFragment,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useCurriculum';
import { curriculumHasDuplicatedCourses } from 'bundles/degree-home/components/v3-dpm/lib/gradeUtils';

interface CurriculumsRendererProps {
  curriculumsData: Array<DegreeCurriculumFragment | PbaCurriculumFragment>;
}

const styles = {
  curriculumsContainer: () => css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-400);
  `,
  curriculum: () => css`
    ${breakpoints.down('xs')} {
      background: var(--cds-color-grey-25);
    }
  `,
  duplicateCourseContainer: () => css`
    margin-top: var(--cds-spacing-300);
    display: flex;
    align-items: center;
    gap: var(--cds-spacing-50);
  `,
};

const CurriculumsRenderer = ({ curriculumsData }: CurriculumsRendererProps) => {
  return (
    <div css={styles.curriculumsContainer}>
      {curriculumsData.map((curriculum) => (
        <CurriculumDataContextProvider key={curriculum.id} curriculum={curriculum}>
          <div css={styles.curriculum}>
            <CurriclumHeader curriculum={curriculum} />
            {curriculum.categories.map((category: CategoryFragmentProps) => (
              <Category category={category} key={category.id} />
            ))}
            {curriculumHasDuplicatedCourses(curriculum) && (
              <div css={styles.duplicateCourseContainer}>
                <DuplicateCoursesDialog />
              </div>
            )}
          </div>
        </CurriculumDataContextProvider>
      ))}
    </div>
  );
};

export default CurriculumsRenderer;
